/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import Constants, { toISTDate } from '@Apis/constants';
import TenantActions from '@Actions/tenantActions';

function ViewTableCustomFields({
  customField, wrapperClass, valueClass, users, getUsers, user,
}) {
  return (
    <div className="cf_wrapper">
      <div className={wrapperClass}>
        {!['ATTACHMENT', 'CHECKBOX', 'DATE', 'USERS'].includes(customField?.field_type) && (
          <Fragment>
            <H3Text text={customField?.field_value} className={valueClass} />
          </Fragment>
        )}
        {
            customField?.field_type === 'ATTACHMENT' && (
            <Fragment>
              <div style={{ display: 'block' }}>
                {
                    customField?.field_value?.map((file) => {
                    let url = file?.url?.includes('procuzystorage.blob.core.windows.net')
                    ? file.url.replace('https://procuzystorage.blob.core.windows.net/', Constants.CDN_URL)
                    : file.url;
                    return (
                      <div key={file?.name}>
                        <a href={url} target="_blank" rel="noreferrer">{file?.name?.length > 30 ? `${file?.name.substring(0, 30)}...` : file?.name}</a>
                        <br />
                      </div>
                    )})
                }
              </div>
            </Fragment>
          )
        }
        {
            customField?.field_type === 'CHECKBOX' && (
            <Fragment>
              <H3Text text={customField?.field_value ? 'Yes' : 'No'} className={valueClass} />
            </Fragment>
          )
        }
        {
            customField?.field_type === 'USERS' && (
            <Fragment>
              <H3Text text={users?.data?.[0]?.tenant_user?.filter((item) => item?.user_id === customField?.field_value)[0]?.first_name} className={valueClass} />
            </Fragment>
          )
        }
        {
            customField?.field_type === 'DATE' && (
            <Fragment>
              {customField?.field_value && <H3Text text={toISTDate(customField?.field_value).format('DD MMM, YYYY')} className={valueClass} />}
            </Fragment>
          )
        }
      </div>
    </div>
  );
}
const mapStateToProps = ({ TenantReducers, UserReducers }) => ({
  users: TenantReducers.users,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewTableCustomFields));
